import { fetchWithClerkJwt } from "./fetch-with-clerk";

/** Matches API **`toPublicCustomer`** (`services/api/src/customers/public-customer.ts`). */
export type CustomerProfile = {
  id: string;
  clerkUserId: string | null;
  fullName: string;
  email: string | null;
  phone: string;
  dateOfBirth: string;
  defaultAddressLine1: string | null;
  defaultAddressLine2: string | null;
  defaultCity: string | null;
  defaultState: string | null;
  defaultZip: string | null;
  straddleCustomerId: string | null;
  secrets: {
    straddlePaykeyConfigured: boolean;
    plaidItemConfigured: boolean;
    plaidAccessTokenConfigured: boolean;
  };
  bankAccountLast4: string | null;
  bankName: string | null;
  isAgeVerified: boolean;
  ageVerifiedAt: string | null;
  ageVerificationMethod: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export async function fetchCustomerProfile(
  getToken: () => Promise<string | null>,
  customerId: string,
): Promise<CustomerProfile> {
  const path = `/api/v1/customers/${encodeURIComponent(customerId)}`;
  const res = await fetchWithClerkJwt(getToken, path);
  if (!res.ok) {
    throw new Error(`customer_profile_http_${res.status}`);
  }
  return (await res.json()) as CustomerProfile;
}

export function formatCustomerProfileError(err: unknown): string {
  if (!(err instanceof Error)) {
    return "Could not load your profile.";
  }
  const http = /^customer_profile_http_(\d+)$/.exec(err.message);
  if (http) {
    const code = Number(http[1]);
    if (code === 404) {
      return "Customer profile not found.";
    }
    return `Profile request failed (HTTP ${code}).`;
  }
  if (err.message === "clerk_session_missing") {
    return "Sign in again to view your account.";
  }
  if (err.message.includes("Failed to fetch") || err.name === "TypeError") {
    return "Could not reach the API. Check your connection or VITE_API_BASE_URL.";
  }
  return err.message || "Could not load your profile.";
}
